import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 10/12;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 10 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.235 10.47l-.882-1.764-.882 1.763 1.764.002zm-2.141 1.173l-.385.855c-.13.29-.449.409-.71.263-.262-.145-.368-.498-.237-.789l2.117-4.706c.196-.433.752-.433.947 0l2.118 4.706c.13.29.025.644-.237.79-.261.145-.58.027-.71-.264l-.384-.853-2.519-.002zM9.237 4h.528c.292 0 .53.25.53.559 0 .308-.238.559-.53.559h-.528c-.587 0-1.06.499-1.06 1.119v6.703c0 .619.473 1.119 1.06 1.119h.528c.292 0 .53.25.53.559 0 .308-.238.558-.53.558h-.528a2.067 2.067 0 0 1-1.59-.757 2.067 2.067 0 0 1-1.59.757H5.53c-.292 0-.529-.25-.529-.558 0-.309.237-.56.53-.56h.527c.587 0 1.06-.5 1.06-1.118V6.237c0-.62-.473-1.12-1.06-1.12H5.53c-.292 0-.529-.25-.529-.558C5 4.25 5.237 4 5.53 4h.527c.634 0 1.202.292 1.59.757A2.067 2.067 0 0 1 9.237 4z" transform="translate(-5 -4)" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconCustomField extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
